export const schedules = {
  'Are you sure you want to cancel the session?':
    'Tem certeza que deseja cancelar a sessão?',
  'Cancel session': 'Cancelar sessão',
  'Cancelled less than {{hours}}h in advance':
    'Cancelado com menos de {{hours}}h de antecedência',
  'Cancelled more than {{hours}}h in advance':
    'Cancelado com mais de {{hours}}h de antecedência',
  'Discounted session': 'Sessão descontada',
  '{{date}} at {{time}}': '{{date}} às {{time}}',
  Finished: 'Concluida',
  'Inform the reason for the cancellation': 'Informe o motivo do cancelamento',
  'Next Sessions': 'Próximas sessões',
  Reschedule: 'Reagendar',
  Schedule: 'Agendar',
  Schedules: 'Agendamentos',
  'Schedules History': 'Histórico de Agendamentos',
  Today: 'Hoje',
  Tomorrow: 'Amanhã',
  'Unable to reschedule': 'Não é possível reagendar',
  Understood: 'Entendi',
  'View your schedules, reschedule or appoint your new sessions':
    'Visualize seus agendamentos, reagende ou marque sua próxima sessão',
  "You don't have any past schedules":
    'Você não tem nenhum agendamento anterior',
};
